import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { http } from '../../services/HttpInterceptor';
import {
    RouteComponentProps, Link
} from "react-router-dom";
import { toast } from 'react-toastify';
import swal from 'sweetalert';
import { observable } from 'mobx';
import { sessionService } from '../../services/SessionService';

interface IndexAntennaProps extends RouteComponentProps {
    changeToggle(action?: boolean): void
}
@observer export default class IndexAntenna extends React.Component<IndexAntennaProps> {

    @observable private antennas: any;
    @observable private isLoaded = false;

    componentDidMount() {
        this.props.changeToggle(true);
        this.init();
    }

    init = () => {
        http.get('/api/antenna/read').then((response) => {
            this.antennas = response.data.response;
            this.isLoaded = true;
        }).catch(() => {
            toast.error("Error cargando paquetes");
        });
    }

    render() {
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });
        if (!this.isLoaded) {
            return null;
        }
        return (
            <Fragment>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header card-header-primary">
                                <h4 className="card-title ">Lista de antenas</h4>
                                <p className="card-category">Lista de antenas registradas</p>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-sm-10"></div>
                                    <div className="col-sm-2">
                                        {sessionService.canViewSection("Antenas.add") &&
                                            <Link to={`/antenas/nuevo`}>
                                                <button className="btn btn-info btn-lg  pull-right">
                                                    <i className="material-icons">account_circle</i> Nueva Antena
                                                <div className="ripple-container"></div>
                                                </button>
                                            </Link>
                                        }
                                    </div>
                                </div>
                                <div className="table-responsive">
                                    <table className="table">
                                        <thead className=" text-primary">
                                            <tr>
                                                <th>ID</th>
                                                <th>Antena</th>
                                                <th>Nombre</th>
                                                <th>Teléfono</th>
                                                <th>Direccion</th>
                                                <th>Cantidad</th>
                                                <th className="text-right">Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.antennas.map((antenna: any, index: any) => {
                                                    return (
                                                        <Fragment key={index}>
                                                            <tr>
                                                                <td>{antenna.id}</td>
                                                                <td>{antenna.antenna_name}</td>
                                                                <td>{antenna.name}</td>
                                                                <td>{antenna.phone}</td>
                                                                <td>{antenna.full_address}</td>
                                                                <td>{formatter.format(antenna.amount)}</td>
                                                                <td className="td-actions text-right">
                                                                    {sessionService.canViewSection("Antenas.edit") &&
                                                                        <Link to={`antenas/${antenna.id}`}>
                                                                            <button style={{ margin: 5 }} type="button" className="btn btn-success">
                                                                                <i className="material-icons">edit</i>
                                                                            </button>
                                                                        </Link>
                                                                    }
                                                                    {sessionService.canViewSection("Antenas.delete") &&
                                                                        <button onClick={() => this.deleteAntenna(antenna.id, index)} style={{ margin: 5 }} type="button" className="btn btn-danger" >
                                                                            <i className="material-icons">close</i>
                                                                        </button>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        </Fragment>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }

    private deleteAntenna = (id: any, index: any): void => {
        swal({
            title: "Confirmar acción",
            text: "¿Estas seguro que quieres borrar la antena?",
            icon: "warning",
            dangerMode: true,
        })
            .then(willDelete => {
                if (willDelete) {
                    const deleteObject = JSON.stringify({
                        id
                    });
                    http.post(`/api/antenna/delete`, deleteObject)
                        .then((response) => {
                            this.antennas.splice(index, 1);
                            toast.success("Antena borrado correctamente");
                        }).catch((error) => {
                            if (error.includes("foreign")) {
                                toast.error("Error al borrar: Registros ligados a esta antena");
                            } else {
                                toast.error("Error borrando antena");
                            }
                        })
                }
            });
    }
}